/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInvitationRequest } from '../models/AcceptInvitationRequest';
import type { Agent } from '../models/Agent';
import type { CreateAgentRequest } from '../models/CreateAgentRequest';
import type { DataSource } from '../models/DataSource';
import type { InvitationResponse } from '../models/InvitationResponse';
import type { InviteUserRequest } from '../models/InviteUserRequest';
import type { PaginationInfo } from '../models/PaginationInfo';
import type { PermissionResponse } from '../models/PermissionResponse';
import type { SharedAgentResponse } from '../models/SharedAgentResponse';
import type { UpdateAgentRequest } from '../models/UpdateAgentRequest';
import type { UpdatePermissionRequest } from '../models/UpdatePermissionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AgentManagementService {
    /**
     * List agents
     * Get paginated list of database agents
     * @returns any Agents retrieved successfully
     * @throws ApiError
     */
    public static getAgents({
        page = 1,
        limit = 20,
        search,
        status,
        connectionStatus,
    }: {
        /**
         * Page number for pagination
         */
        page?: number,
        /**
         * Number of items per page
         */
        limit?: number,
        /**
         * Search agents by name or description
         */
        search?: string,
        /**
         * Filter by agent status
         */
        status?: 'active' | 'inactive',
        /**
         * Filter by connection status
         */
        connectionStatus?: 'connected' | 'disconnected' | 'error',
    }): CancelablePromise<{
        data?: Array<Agent>;
        pagination?: PaginationInfo;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'status': status,
                'connection_status': connectionStatus,
            },
            errors: {
                401: `Unauthorized access`,
            },
        });
    }
    /**
     * Create agent
     * Create a new database agent
     * @returns any Agent created successfully
     * @throws ApiError
     */
    public static createAgents({
        requestBody,
    }: {
        requestBody: CreateAgentRequest,
    }): CancelablePromise<{
        agent?: Agent;
        /**
         * Generated API key (shown only once)
         */
        apiKey?: string;
        /**
         * Success message
         */
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/agents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized access`,
            },
        });
    }
    /**
     * Get agent details
     * Retrieve detailed information about an agent
     * @returns Agent Agent details retrieved successfully
     * @throws ApiError
     */
    public static getAgents1({
        agentId,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
    }): CancelablePromise<Agent> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents/{agent_id}',
            path: {
                'agent_id': agentId,
            },
            errors: {
                401: `Unauthorized access`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Update agent
     * Update agent configuration
     * @returns Agent Agent updated successfully
     * @throws ApiError
     */
    public static updateAgents({
        agentId,
        requestBody,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        requestBody: UpdateAgentRequest,
    }): CancelablePromise<Agent> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/agents/{agent_id}',
            path: {
                'agent_id': agentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized access`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Delete agent
     * Remove an agent (requires owner or write permission)
     * @returns void
     * @throws ApiError
     */
    public static deleteAgents({
        agentId,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/agents/{agent_id}',
            path: {
                'agent_id': agentId,
            },
            errors: {
                401: `Unauthorized access`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Regenerate agent API key
     * Generate a new API key for an existing agent (requires owner or write permission)
     * @returns any API key regenerated successfully
     * @throws ApiError
     */
    public static regenerateAgentApiKey({
        agentId,
        requestBody,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        requestBody: Record<string, any>,
    }): CancelablePromise<{
        /**
         * New API key for the agent
         */
        apiKey?: string;
        /**
         * API key expiration timestamp
         */
        expiresAt?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/agents/{agent_id}/regenerate-api-key',
            path: {
                'agent_id': agentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized access`,
                404: `Agent not found`,
            },
        });
    }
    /**
     * Get agent status
     * Retrieve current status and connection information for an agent
     * @returns any Agent status retrieved successfully
     * @throws ApiError
     */
    public static getAgentStatus({
        agentId,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
    }): CancelablePromise<{
        /**
         * Agent identifier
         */
        id?: string;
        /**
         * Agent name
         */
        name?: string;
        /**
         * Current connection status
         */
        connection_status?: 'connected' | 'disconnected' | 'error';
        /**
         * Whether the agent is active
         */
        is_active?: boolean;
        /**
         * Timestamp of last connection
         */
        last_connected_at?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents/{agent_id}/status',
            path: {
                'agent_id': agentId,
            },
            errors: {
                401: `Unauthorized access`,
                404: `Agent not found`,
            },
        });
    }
    /**
     * Get agent datasources
     * Retrieve all datasources associated with a specific agent
     * @returns any Agent datasources retrieved successfully
     * @throws ApiError
     */
    public static getAgentDatasources({
        agentId,
        page = 1,
        limit = 20,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        /**
         * Page number for pagination
         */
        page?: number,
        /**
         * Number of items per page
         */
        limit?: number,
    }): CancelablePromise<{
        agent?: Agent;
        datasources?: Array<DataSource>;
        pagination?: PaginationInfo;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents/{agent_id}/datasources',
            path: {
                'agent_id': agentId,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized access`,
                404: `Agent not found`,
            },
        });
    }
    /**
     * Reset agent API key
     * Reset the API key for an agent with a new provided key (requires owner or write permission)
     * @returns any API key reset successfully
     * @throws ApiError
     */
    public static resetAgentApiKey({
        agentId,
        requestBody,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        requestBody: {
            /**
             * New API key for the agent
             */
            apiKey: string;
        },
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/agents/{agent_id}/reset-api-key',
            path: {
                'agent_id': agentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized access`,
                404: `Agent not found`,
            },
        });
    }
    /**
     * Invite user to share agent
     * Send an invitation to share an agent with another user via email or username.
     *
     * **User Validation:** The system validates that the specified user exists before sending the invitation.
     * If no user is found with the provided email or username, a 404 USER_NOT_FOUND error is returned.
     *
     * @returns InvitationResponse Invitation sent successfully
     * @throws ApiError
     */
    public static inviteUserToAgent({
        agentId,
        requestBody,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        requestBody: InviteUserRequest,
    }): CancelablePromise<InvitationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/agents/{agent_id}/invite',
            path: {
                'agent_id': agentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized access`,
                403: `Forbidden - No permission to share`,
                404: `Agent or user not found`,
            },
        });
    }
    /**
     * Accept agent invitation
     * Accept an invitation to share an agent
     * @returns any Invitation accepted successfully
     * @throws ApiError
     */
    public static acceptInvitation({
        requestBody,
    }: {
        requestBody: AcceptInvitationRequest,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/agents/invitations/accept',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid invitation`,
                401: `Unauthorized access`,
                403: `Forbidden - Not your invitation`,
                404: `Invitation not found`,
            },
        });
    }
    /**
     * Reject agent invitation
     * Reject an invitation to share an agent
     * @returns any Invitation rejected successfully
     * @throws ApiError
     */
    public static rejectInvitation({
        invitationToken,
        requestBody,
    }: {
        /**
         * Invitation identifier
         */
        invitationToken: string,
        requestBody: Record<string, any>,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/agents/invitations/{invitation_token}/reject',
            path: {
                'invitation_token': invitationToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Invalid invitation status`,
                401: `Unauthorized access`,
                403: `Forbidden - Not your invitation`,
                404: `Invitation not found`,
            },
        });
    }
    /**
     * List agent invitations
     * List all invitations for a specific agent. Only the agent owner can view this list. Returns invitations in all states (pending, accepted, rejected, expired).
     * @returns InvitationResponse List of invitations retrieved successfully
     * @throws ApiError
     */
    public static listAgentInvitations({
        agentId,
        statusFilter,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        /**
         * Filter invitations by status
         */
        statusFilter?: 'pending' | 'accepted' | 'rejected' | 'expired',
    }): CancelablePromise<Array<InvitationResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents/{agent_id}/invitations',
            path: {
                'agent_id': agentId,
            },
            query: {
                'status_filter': statusFilter,
            },
            errors: {
                400: `Bad request - Invalid status filter`,
                401: `Unauthorized access`,
                403: `Forbidden - Not authorized to view invitations`,
                404: `Agent not found`,
            },
        });
    }
    /**
     * Revoke agent invitation
     * Revoke a pending invitation to share an agent. Only the inviter or agent owner can revoke invitations.
     * @returns void
     * @throws ApiError
     */
    public static revokeInvitation({
        agentId,
        invitationToken,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        /**
         * Invitation token identifier
         */
        invitationToken: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/agents/{agent_id}/invitations/{invitation_token}/revoke',
            path: {
                'agent_id': agentId,
                'invitation_token': invitationToken,
            },
            errors: {
                400: `Bad request - Cannot revoke invitation`,
                401: `Unauthorized access`,
                403: `Forbidden - Not authorized to revoke`,
                404: `Invitation or agent not found`,
            },
        });
    }
    /**
     * List agent permissions
     * List all users who have access to an agent (only visible to owner and users with write permission)
     * @returns PermissionResponse Agent permissions retrieved successfully
     * @throws ApiError
     */
    public static listAgentPermissions({
        agentId,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
    }): CancelablePromise<Array<PermissionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents/{agent_id}/permissions',
            path: {
                'agent_id': agentId,
            },
            errors: {
                401: `Unauthorized access`,
                403: `Forbidden - No permission to view`,
                404: `Agent not found`,
            },
        });
    }
    /**
     * Update user permission
     * Update a user's permission level for an agent (requires owner or write permission).
     * Note: If the owner is removed, ownership transfers to the user performing the action.
     *
     * @returns PermissionResponse Permission updated successfully
     * @throws ApiError
     */
    public static updateAgentPermission({
        agentId,
        userId,
        requestBody,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        /**
         * User identifier
         */
        userId: string,
        requestBody: UpdatePermissionRequest,
    }): CancelablePromise<PermissionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/agents/{agent_id}/permissions/{user_id}',
            path: {
                'agent_id': agentId,
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized access`,
                403: `Forbidden - Requires owner or write permission`,
                404: `Not found`,
            },
        });
    }
    /**
     * Remove user access
     * Remove a user's access to an agent (requires owner or write permission).
     * Note: If the owner is removed, ownership transfers to the user performing the action.
     *
     * @returns void
     * @throws ApiError
     */
    public static removeAgentPermission({
        agentId,
        userId,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
        /**
         * User identifier
         */
        userId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/agents/{agent_id}/permissions/{user_id}',
            path: {
                'agent_id': agentId,
                'user_id': userId,
            },
            errors: {
                400: `Bad request - Validation error`,
                401: `Unauthorized access`,
                403: `Forbidden - Only owner can remove`,
                404: `Not found`,
            },
        });
    }
    /**
     * Leave shared agent
     * Remove yourself from a shared agent (users can only remove themselves)
     * @returns void
     * @throws ApiError
     */
    public static leaveSharedAgent({
        agentId,
    }: {
        /**
         * Agent identifier
         */
        agentId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/agents/{agent_id}/leave',
            path: {
                'agent_id': agentId,
            },
            errors: {
                400: `Bad request - Cannot leave own agent`,
                401: `Unauthorized access`,
                403: `Forbidden - No permission`,
                404: `Agent not found`,
            },
        });
    }
    /**
     * List shared agents
     * List all agents that have been shared with the current user
     * @returns SharedAgentResponse Shared agents retrieved successfully
     * @throws ApiError
     */
    public static listSharedAgents({
        page = 1,
        limit = 20,
    }: {
        /**
         * Page number for pagination
         */
        page?: number,
        /**
         * Number of items per page
         */
        limit?: number,
    }): CancelablePromise<Array<SharedAgentResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents/shared',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized access`,
            },
        });
    }
    /**
     * List my invitations
     * List all pending invitations for the current user
     * @returns InvitationResponse Invitations retrieved successfully
     * @throws ApiError
     */
    public static listMyInvitations({
        statusFilter,
    }: {
        /**
         * Filter invitations by status
         */
        statusFilter?: 'pending' | 'accepted' | 'rejected' | 'expired',
    }): CancelablePromise<Array<InvitationResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/agents/invitations',
            query: {
                'status_filter': statusFilter,
            },
            errors: {
                400: `Bad request - Invalid filter`,
                401: `Unauthorized access`,
            },
        });
    }
}
